import {default as Error} from './Error';
import {default as Cancel} from './Cancel';
import {default as SelectDevice} from './SelectDevice';

export default {Error, Cancel, SelectDevice};